import styled, { CSSObject, css } from 'styled-components';

export const Wrapper = styled.div<{ active?: boolean }>`
  border: 1px solid ${(props) => (props.active ? '#0046FF' : 'rgba(0, 0, 0, 0.15)')};
  border-radius: 4px;
  margin-bottom: 16px;
`;

export const RootContainer = styled.div<{ style?: CSSObject }>`
  height: 100%;
  width: 100%;
  background-color: white;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px; /* 142.857% */
  letter-spacing: -0.14px;
  ${({ style }) => {
    if (style) {
      return css`
        ${style}
      `;
    }
    return {};
  }}
`;

export const ItemRootContainer = styled.div`
  width: 100%;
`;

export const ItemContainer = styled.div<{ selected?: boolean }>`
  display: flex;
  align-items: center;
  background-color: ${(props) => (props.selected ? '#e9f3fd' : '#fff')};
  color: ${(props) => (props.selected ? '#0046FF' : 'rgba(0, 0, 0, 0.88)')};
  cursor: pointer;
  transition: all 0.3s ease-in-out;
  border-radius: 4px;
  margin: 2px 0;

  &:hover {
    background-color: ${(props) => (props.selected ? '#d1ecf1' : '#f5f5f5')};
    transform: translateY(-2px);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
`;

export const IconContainer = styled.div`
  width: 20px;
  font-size: 12px;
  display: flex;
  align-items: center;
  color: #494949;
`;

export const LabelContainer = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
  padding: 12px 4px;
  border-bottom: 1px solid #e8e8e8;
  width: 100%;
`;

export const ChildrenContainer = styled.div`
  margin-left: 20px;
  font-weight: 400;
`;
